module.exports = __webpack_public_path__ + "static/spielplatz2-7f7b1e0c8f1ef1e16fb9b50e26d5f392.PNG";